/**
 *
 * Asynchronously loads the BulkSendEmailPopup component
 *
 */

import loadable from 'utils/loadable';

export default loadable(() => import('./index'));
